let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ambg9")).then(() => parcelRequire('daUsC'));